import DateCleanStorageService from "./DateCleanStorageService";
import {autoFormatDate, DATE_FORMAT_WITHOUT_TIME} from "../../UtilsService";
import OperationLocalService from "./OperationLocalService";

class CleanService {

    /**
     * Clean local storage if the last cleaning was before today
     * @private
     */
    public cleanStorageIfNecessary() {
        if(this.doesStorageNeedCleaned()) {
            try {
                OperationLocalService.cleanLocalStorage();
                DateCleanStorageService.createLastCleaningDate(new Date());
            } catch (e) {
                console.log(e);
            }
        }
    }

    /**
     * Checks the last cleaning date and compares it to today
     * @private
     */
    private doesStorageNeedCleaned(): boolean {
        let lastReset = DateCleanStorageService.getLastCleaningDate();
        if(lastReset === undefined) {
            lastReset = new Date();
            DateCleanStorageService.createLastCleaningDate(lastReset);
        }
        return (autoFormatDate(new Date(), DATE_FORMAT_WITHOUT_TIME) !== autoFormatDate(lastReset, DATE_FORMAT_WITHOUT_TIME));
    }

}

export default new CleanService();
